
document.addEventListener('DOMContentLoaded', function () {
  const shippingRates = {
    "Standard": {
      "Normal shipping": {
        "weight_range": "0",
        "regions": {
          "1000-2263, 2500-2530, 2555-2574, 2740-2786, 2890": 10,
          "0200-0299, 2264-2484, 2485-2499, 2531-2554, 2575-2639, 2640-2647, 2649-2714, 2716, 2720-2730, 2787-2879, 2881-2889, 2891-2898, 2900-2999": 10,
          "3000-3220, 3335-3341, 3425-3443, 3750-3811, 3910-3920, 3926-3944, 3972-3978, 3980-3983, 8000-8999": 10,
          "2648, 2715, 2731-2739, 3221-3334, 3342-2424, 3444-3688, 3689-3749, 3812-3909, 3921-3925, 3945-3971, 3979, 3984-3999": 10,
          "4000-4299, 4500-4549, 9000-9299, 9400-9596, 9700-9799": 10,
          "4300-4449, 4550-4699, 9597-9599, 9880-9919": 10,
          "4450-4499, 4700-4899, 9920-9959": 10,
          "5000-5199, 5800-5999": 10,
          "5200-5749": 10,
          "0800-0999": 10,
          "6000-6214, 6800-6999": 10,
          "6215-6699, 6700-6797": 10,
          "7000-7999": 10,
          "NF": 10,
          "NZ": 25
        }
      },
      "Bulky Items": {
       "weight_range": "0.001-0.009",
      "regions": {
        "1000-2263, 2500-2530, 2555-2574, 2740-2786, 2890": 25.0,
        "0200-0299, 2264-2484, 2485-2499, 2531-2554, 2575-2639, 2640-2647, 2649-2714, 2716, 2720-2730, 2787-2879, 2881-2889, 2891-2898, 2900-2999": 25.0,
        "3000-3220, 3335-3341, 3425-3443, 3750-3811, 3910-3920, 3926-3944, 3972-3978, 3980-3983, 8000-8999": 25.0,
        "2648, 2715, 2731-2739, 3221-3334, 3342-2424, 3444-3688, 3689-3749, 3812-3909, 3921-3925, 3945-3971, 3979, 3984-3999": 30.0,
        "4000-4299, 4500-4549, 9000-9299, 9400-9596, 9700-9799": 25.0,
        "4300-4449, 4550-4699, 9597-9599, 9880-9919": 30.0,
        "4450-4499, 4700-4899, 9920-9959": 35.0,
        "5000-5199, 5800-5999": 25.0,
        "5200-5749": 30.0,
        "0800-0999": 35.0,
        "6000-6214, 6800-6999": 35.0,
        "6215-6699, 6700-6797": 40.0,
        "7000-7999": 30.0,
        "NF": 40.0,
        "NZ": 40.0
      },
       "Extra bulky items": {
      "weight_range": "0.01-0.09",
      "regions": {
        "1000-2263, 2500-2530, 2555-2574, 2740-2786, 2890": 30.0,
        "0200-0299, 2264-2484, 2485-2499, 2531-2554, 2575-2639, 2640-2647, 2649-2714, 2716, 2720-2730, 2787-2879, 2881-2889, 2891-2898, 2900-2999": 50.0,
        "3000-3220, 3335-3341, 3425-3443, 3750-3811, 3910-3920, 3926-3944, 3972-3978, 3980-3983, 8000-8999": 50.0,
        "2648, 2715, 2731-2739, 3221-3334, 3342-2424, 3444-3688, 3689-3749, 3812-3909, 3921-3925, 3945-3971, 3979, 3984-3999": 60.0,
        "4000-4299, 4500-4549, 9000-9299, 9400-9596, 9700-9799": 50.0,
        "4300-4449, 4550-4699, 9597-9599, 9880-9919": 75.0,
        "4450-4499, 4700-4899, 9920-9959": 100.0,
        "5000-5199, 5800-5999": 50.0,
        "5200-5749": 75.0,
        "0800-0999": 100.0,
        "6000-6214, 6800-6999": 100.0,
        "6215-6699, 6700-6797": 150.0,
        "7000-7999": 75.0,
        "NF": 150.0
      }
    }
    },
    "Brompton (Auspost)": {
      "weight_range": "0.1-0.9",
      "regions": {
        "1000-2263, 2500-2530, 2555-2574, 2740-2786, 2890": 90.0,
        "0200-0299, 2264-2484, 2485-2499, 2531-2554, 2575-2639, 2640-2647, 2649-2714, 2716, 2720-2730, 2787-2879, 2881-2889, 2891-2898, 2900-2999": 150.0,
        "3000-3220, 3335-3341, 3425-3443, 3750-3811, 3910-3920, 3926-3944, 3972-3978, 3980-3983, 8000-8999": 100.0,
        "2648, 2715, 2731-2739, 3221-3334, 3342-2424, 3444-3688, 3689-3749, 3812-3909, 3921-3925, 3945-3971, 3979, 3984-3999": 150.0,
        "4000-4299, 4500-4549, 9000-9299, 9400-9596, 9700-9799": 100.0,
        "4300-4449, 4550-4699, 9597-9599, 9880-9919": 150.0,
        "4450-4499, 4700-4899, 9920-9959": 200.0,
        "5000-5199, 5800-5999": 150.0,
        "5200-5749": 200.0,
        "0800-0999": 200.0,
        "6000-6214, 6800-6999": 150.0,
        "6215-6699, 6700-6797": 200.0,
        "7000-7999": 150.0,
        "NF": 250.0
      }
    },
    "Push Bike (Depot)": {
      "weight_range": "1-9",
      "regions": {
        "1000-2263, 2500-2530, 2555-2574, 2740-2786, 2890": 120.0,
        "0200-0299, 2264-2484, 2485-2499, 2531-2554, 2575-2639, 2640-2647, 2649-2714, 2716, 2720-2730, 2787-2879, 2881-2889, 2891-2898, 2900-2999": 150.0,
        "3000-3220, 3335-3341, 3425-3443, 3750-3811, 3910-3920, 3926-3944, 3972-3978, 3980-3983, 8000-8999": 150.0,
        "2648, 2715, 2731-2739, 3221-3334, 3342-2424, 3444-3688, 3689-3749, 3812-3909, 3921-3925, 3945-3971, 3979, 3984-3999": 200.0,
        "4000-4299, 4500-4549, 9000-9299, 9400-9596, 9700-9799": 150.0,
        "4300-4449, 4550-4699, 9597-9599, 9880-9919": 200.0,
        "4450-4499, 4700-4899, 9920-9959": 250.0,
        "5000-5199, 5800-5999": 200.0,
        "5200-5749": 300.0,
        "0800-0999": 300.0,
        "6000-6214, 6800-6999": 200.0,
        "6215-6699, 6700-6797": 300.0,
        "7000-7999": 200.0
      }
    },
    "E-Bike (Depot)": {
      "weight_range": "10-99",
      "regions": {
        "1000-2263, 2500-2530, 2555-2574, 2740-2786, 2890": 150.0,
        "0200-0299, 2264-2484, 2485-2499, 2531-2554, 2575-2639, 2640-2647, 2649-2714, 2716, 2720-2730, 2787-2879, 2881-2889, 2891-2898, 2900-2999": 250.0,
        "3000-3220, 3335-3341, 3425-3443, 3750-3811, 3910-3920, 3926-3944, 3972-3978, 3980-3983, 8000-8999": 200.0,
        "2648, 2715, 2731-2739, 3221-3334, 3342-2424, 3444-3688, 3689-3749, 3812-3909, 3921-3925, 3945-3971, 3979, 3984-3999": 250.0,
        "4000-4299, 4500-4549, 9000-9299, 9400-9596, 9700-9799": 200.0,
        "4300-4449, 4550-4699, 9597-9599, 9880-9919": 350.0,
        "4450-4499, 4700-4899, 9920-9959": 450.0,
        "5000-5199, 5800-5999": 350.0,
        "5200-5749": 450.0,
        "0800-0999": 450.0,
        "6000-6214, 6800-6999": 400.0,
        "6215-6699, 6700-6797": 450.0,
        "7000-7999": 250.0
      }
    },
    "Cargo Bike (Depot)": {
      "weight_range": "100-999",
      "regions": {
        "1000-2263, 2500-2530, 2555-2574, 2740-2786, 2890": 120.0,
        "0200-0299, 2264-2484, 2485-2499, 2531-2554, 2575-2639, 2640-2647, 2649-2714, 2716, 2720-2730, 2787-2879, 2881-2889, 2891-2898, 2900-2999": 150.0,
        "3000-3220, 3335-3341, 3425-3443, 3750-3811, 3910-3920, 3926-3944, 3972-3978, 3980-3983, 8000-8999": 150.0,
        "2648, 2715, 2731-2739, 3221-3334, 3342-2424, 3444-3688, 3689-3749, 3812-3909, 3921-3925, 3945-3971, 3979, 3984-3999": 200.0,
        "4000-4299, 4500-4549, 9000-9299, 9400-9596, 9700-9799": 150.0,
        "4300-4449, 4550-4699, 9597-9599, 9880-9919": 250.0,
        "4450-4499, 4700-4899, 9920-9959": 300.0,
        "5000-5199, 5800-5999": 250.0,
        "5200-5749": 400.0,
        "0800-0999": 400.0,
        "6000-6214, 6800-6999": 350.0,
        "6215-6699, 6700-6797": 400.0,
        "7000-7999": 200.0
      }
    },
    "E-Cargo Bike (Depot)": {
      "weight_range": "1000",
      "regions": {
        "1000-2263, 2500-2530, 2555-2574, 2740-2786, 2890": 150.0,
        "0200-0299, 2264-2484, 2485-2499, 2531-2554, 2575-2639, 2640-2647, 2649-2714, 2716, 2720-2730, 2787-2879, 2881-2889, 2891-2898, 2900-2999": 300.0,
        "3000-3220, 3335-3341, 3425-3443, 3750-3811, 3910-3920, 3926-3944, 3972-3978, 3980-3983, 8000-8999": 300.0,
        "2648, 2715, 2731-2739, 3221-3334, 3342-2424, 3444-3688, 3689-3749, 3812-3909, 3921-3925, 3945-3971, 3979, 3984-3999": 350.0,
        "4000-4299, 4500-4549, 9000-9299, 9400-9596, 9700-9799": 300.0,
        "4300-4449, 4550-4699, 9597-9599, 9880-9919": 400.0,
        "4450-4499, 4700-4899, 9920-9959": 600.0,
        "5000-5199, 5800-5999": 400.0,
        "5200-5749": 600.0,
        "0800-0999": 600.0,
        "6000-6214, 6800-6999": 600.0,
        "6215-6699, 6700-6797": 800.0,
        "7000-7999": 600.0
      }
    }
  },
  "Express": {
    "Express shipping": {
      "weight_range": "0",
     "regions": {
        "1000-2263, 2500-2530, 2555-2574, 2740-2786, 2890": 30.0,
        "0200-0299, 2264-2484, 2485-2499, 2531-2554, 2575-2639, 2640-2647, 2649-2714, 2716, 2720-2730, 2787-2879, 2881-2889, 2891-2898, 2900-2999": 18.0,
        "3000-3220, 3335-3341, 3425-3443, 3750-3811, 3910-3920, 3926-3944, 3972-3978, 3980-3983, 8000-8999": 18.0,
        "2648, 2715, 2731-2739, 3221-3334, 3342-2424, 3444-3688, 3689-3749, 3812-3909, 3921-3925, 3945-3971, 3979, 3984-3999": 18.0,
        "4000-4299, 4500-4549, 9000-9299, 9400-9596, 9700-9799": 18.0,
        "4300-4449, 4550-4699, 9597-9599, 9880-9919": 18.0,
        "4450-4499, 4700-4899, 9920-9959": 18.0,
        "5000-5199, 5800-5999": 18.0,
        "5200-5749": 18.0,
        "0800-0999": 18.0,
        "6000-6214, 6800-6999": 18.0,
        "6215-6699, 6700-6797":18.0,
        "7000-7999": 18.0,
        "NF": 18.0,
        "NZ": 35.0
      }
    },
    "Bulky Items": {
      "weight_range": "0.001-0.009",
      "regions": {
        "1000-2263, 2500-2530, 2555-2574, 2740-2786, 2890": 30.0,
        "0200-0299, 2264-2484, 2485-2499, 2531-2554, 2575-2639, 2640-2647, 2649-2714, 2716, 2720-2730, 2787-2879, 2881-2889, 2891-2898, 2900-2999": 45.0,
        "3000-3220, 3335-3341, 3425-3443, 3750-3811, 3910-3920, 3926-3944, 3972-3978, 3980-3983, 8000-8999": 60.0,
        "2648, 2715, 2731-2739, 3221-3334, 3342-2424, 3444-3688, 3689-3749, 3812-3909, 3921-3925, 3945-3971, 3979, 3984-3999": 80.0,
        "4000-4299, 4500-4549, 9000-9299, 9400-9596, 9700-9799": 60.0,
        "4300-4449, 4550-4699, 9597-9599, 9880-9919": 80.0,
        "4450-4499, 4700-4899, 9920-9959": 120.0,
        "5000-5199, 5800-5999": 80.0,
        "5200-5749": 120.0,
        "0800-0999": 80.0,
        "6000-6214, 6800-6999": 80.0,
        "6215-6699, 6700-6797": 150.0,
        "7000-7999": 80.0,
        "NF": 150.0,
        "NZ": 60.0
      }
    },
    "Extra Bulky Items": {
      "weight_range": "0.01-0.09",
      "regions": {
        "1000-2263, 2500-2530, 2555-2574, 2740-2786, 2890": 35.0,
        "0200-0299, 2264-2484, 2485-2499, 2531-2554, 2575-2639, 2640-2647, 2649-2714, 2716, 2720-2730, 2787-2879, 2881-2889, 2891-2898, 2900-2999": 75.0,
        "3000-3220, 3335-3341, 3425-3443, 3750-3811, 3910-3920, 3926-3944, 3972-3978, 3980-3983, 8000-8999": 90.0,
        "2648, 2715, 2731-2739, 3221-3334, 3342-2424, 3444-3688, 3689-3749, 3812-3909, 3921-3925, 3945-3971, 3979, 3984-3999": 150.0,
        "4000-4299, 4500-4549, 9000-9299, 9400-9596, 9700-9799": 90.0,
        "4300-4449, 4550-4699, 9597-9599, 9880-9919": 150.0,
        "4450-4499, 4700-4899, 9920-9959": 200.0,
        "5000-5199, 5800-5999": 150.0,
        "5200-5749": 200.0,
        "0800-0999": 150.0,
        "6000-6214, 6800-6999": 150.0,
        "6215-6699, 6700-6797": 250.0,
        "7000-7999": 150.0,
        "NF": 250.0,
      }
    }
    }
  };

  function parseRange(rangeStr) {
    const [min, max] = rangeStr.split('-').map(parseFloat);
    return { min, max: max || min };
  }

  function getCategory(weight, type) {
    const types = shippingRates[type];
    for (const key in types) {
      const range = parseRange(types[key].weight_range);
      if (weight >= range.min && weight <= range.max) {
        return key;
      }
    }
    return null;
  }

  function isInRange(postcode, ranges) {
    return ranges.some((rangeStr) => {
      return rangeStr.split(',').some(segment => {
        if (segment.includes('-')) {
          const [start, end] = segment.split('-').map(Number);
          return postcode >= start && postcode <= end;
        }
        return parseInt(segment) === postcode;
      });
    });
  }

  function getRate(postcode, weight, type) {
    const category = getCategory(weight, type);
    if (!category) return null;

    const regions = shippingRates[type][category].regions;
    for (const rangeStr in regions) {
      if (isInRange(postcode, [rangeStr])) return regions[rangeStr];
    }
    return null;
  }

  const el = document.getElementById("shipping-calculator");
  const input = document.getElementById("shipping-postcode");
  const btn = document.getElementById("calculate-shipping");
  const output = document.getElementById("shipping-result");

  if (!el || !input || !btn || !output) return;

  btn.addEventListener("click", () => {
    const postcode = parseInt(input.value.trim(), 10);
    const weight = parseFloat(el.dataset.productWeight);
    if (isNaN(postcode) || isNaN(weight)) {
      output.innerHTML = "<p style='color:red;'>Invalid postcode or weight.</p>";
      return;
    }

const std = getRate(postcode, weight, "Standard");

let exp = null;
const expressCategory = getCategory(weight, "Express");
if (expressCategory) {
  exp = getRate(postcode, weight, "Express");
}


    if (std === null && exp === null) {
      output.innerHTML = "<p style='color:red;'>No rate found for this postcode.</p>";
      return;
    }

    output.innerHTML = `
      ${std !== null ? `<p><strong>Standard:</strong> $${std}</p>` : ''}
      ${exp !== null ? `<p><strong>Express:</strong> $${exp}</p>` : ''}
    `;
  });
});